import { render } from "./resources.vue?vue&type=template&id=2060eeb7&ts=true"
import script from "./resources.vue?vue&type=script&lang=ts"
export * from "./resources.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__